export const CREATE_GOAL_FORM_TEST_IDS = {
  NAME: 'goal-name',
  EVENT: 'goal-event',
  ATTRIBUTION_METHOD: 'goal-attribution',
  APPLY_TO: 'goal-apply-to',
};

export enum ApplyGoalTo {
  AllCampaigns = 'AllCampaigns',
  SomeCampaigns = 'SomeCampaigns',
}

/**
 * CreateGoalForm field names
 */
export const GOAL_NAME_FIELD = 'name';
export const EVENT_NAME_FIELD = 'eventName';
export const ATTRIBUTION_MODE_FIELD = 'attributionMode';
export const ATTRIBUTION_MODE_HOURS_FIELD = 'periodHours';
export const APPLY_GOAL_TO_FIELD = 'applyGoalTo';
export const CAMPAIGN_LABELS_FIELD = 'campaignLabelIds';
export const MESSAGE_TYPES_FIELD = 'messageTypeIds';

/**
 * Maximum number of campaign labels that a goal can be applied to
 */
export const MAX_NUMBER_LABELS_FOR_GOAL = 5;

/**
 * Maximum number of campaign message types that a goal can be applied to
 */
export const MAX_NUMBER_MESSAGE_TYPES_FOR_GOAL = 5;

/**
 * Delimiter for event type and event name in the EVENT_NAME_FIELD field
 */
export const EVENT_TYPE_DELIMITER = '___:___';

/**
 * Name of the purchase event
 */
export const PURCHASE_EVENT_NAME = 'iterable_purchase';

/**
 * Maximum length of the goal name
 */
export const GOAL_NAME_MAX_LENGTH = 255;
